import { render, staticRenderFns } from "./CBCInputVue.vue?vue&type=template&id=7dd2c037"
import script from "./CBCInputVue.vue?vue&type=script&lang=js"
export * from "./CBCInputVue.vue?vue&type=script&lang=js"
import style0 from "./CBCInputVue.vue?vue&type=style&index=0&id=7dd2c037&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports